export default "__VITE_ASSET__Dh9vJPp$__"